import { PublicClientApplication, InteractionRequiredAuthError } from "@azure/msal-browser";

const isDev = process.env.NODE_ENV === "development";

const CLIENT_ID = "419f1a53-b72f-467d-ab77-8d2bc79c0f5a";

const msalConfig = {
  auth: {
    clientId: CLIENT_ID,
    authority: "https://organizerassistant.b2clogin.com/organizerassistant.onmicrosoft.com/B2C_1_signupsignin1",
    knownAuthorities: ["organizerassistant.b2clogin.com"],
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage",
  },
};

// Requesting the app's own client id as a scope makes B2C issue an access
// token (plus a refresh token) with the same issuer and audience the web-api
// already validates, without exposing a separate API scope in the portal.
// The theme prefs ride along as query params so the custom B2C login page
// (public/b2c-login.html) can render with the user's palette; it falls back
// to the defaults when they're absent.
function tokenRequest() {
  return {
    scopes: [CLIENT_ID],
    extraQueryParameters: {
      ui_gradient: window.localStorage.getItem("GRADIENT_STYLE") || "sorbet",
      ui_theme: window.localStorage.getItem("THEME") || "light",
    },
  };
}

// Lazy: MSAL's constructor requires browser crypto, which jsdom (tests) lacks.
let msalInstance = null;
export function getMsalInstance() {
  if (!msalInstance) msalInstance = new PublicClientApplication(msalConfig);
  return msalInstance;
}

// Returns true when the app can render, false when redirecting to B2C.
export async function initAuth() {
  if (isDev) return true;
  // msal-browser v2 has no initialize(); keep the call guarded for v3+ upgrades
  if (getMsalInstance().initialize) await getMsalInstance().initialize();
  await getMsalInstance().handleRedirectPromise();
  const accounts = getMsalInstance().getAllAccounts();
  if (accounts.length === 0) {
    await getMsalInstance().loginRedirect(tokenRequest());
    return false;
  }
  getMsalInstance().setActiveAccount(accounts[0]);
  return true;
}

export async function getToken() {
  if (isDev) return window.localStorage.getItem("AUTHTOKEN");
  try {
    const result = await getMsalInstance().acquireTokenSilent(tokenRequest());
    return result.accessToken || result.idToken;
  } catch (e) {
    if (e instanceof InteractionRequiredAuthError) {
      await getMsalInstance().acquireTokenRedirect(tokenRequest());
      return null; // page is navigating to B2C
    }
    throw e;
  }
}

export function login() {
  if (isDev) return;
  getMsalInstance().loginRedirect(tokenRequest());
}

export function logout() {
  if (isDev) {
    window.localStorage.removeItem("AUTHTOKEN");
    window.localStorage.removeItem("NAME");
    return;
  }
  getMsalInstance().logoutRedirect();
}

export function getAccountName() {
  if (isDev) return window.localStorage.getItem("NAME");
  const account = getMsalInstance().getActiveAccount() || getMsalInstance().getAllAccounts()[0];
  return account ? account.name : "";
}
